export default {
  custom_button: {
    add: "Ja, Hinzufügen",
  },
};
